const MUTANTS_CONTRACT_ADDRESS = "0xa50a7a99c6937ab77E075199D23450086b2Db7bC";
const DAC_CONTRACT_ADDRESS = "0x8e311dB45B55DF68b7C1C8D01888a4C43986c60F";

export { MUTANTS_CONTRACT_ADDRESS, DAC_CONTRACT_ADDRESS };
